export const LOCATION_WIDGET_COUNTRY_LABEL = 'Country';
export const LOCATION_WIDGET_LOCAL_LABEL = 'Local Location';
export const LOCATION_WIDGET_CITY_LABEL = 'City';
